import React, { FunctionComponent } from 'react';

import { Button } from './chroma';

interface SubmitButtonProps {
  enabled: boolean;
  onClick?: Function;
}

export const SubmitButton: FunctionComponent<SubmitButtonProps> = ({
  enabled,
  onClick,
  children,
}) => (
  <Button
    primary
    size="lg"
    type="submit"
    maxWidth
    disabled={!enabled}
    onClick={onClick}
  >
    {children}
  </Button>
);

export default SubmitButton;
